import React, { useState } from 'react';
import './multiLevelTable.css';
import MultiQtyCell from '../dms_common/MultiQtyCell';
import MultiLevelSubTable from './multiLevelSubTable';
import { ReactComponent as EditPen } from "../../assets/image/svg/editPen.svg";
import RenderSvg from '../renderSvg/RenderSvg';


interface ColumnMetaData {
    headerName: string;
    width: string;
    align?: string;
    mappedValue?: string;
    displayType?: string;
    hasEditPenSvg?: boolean;
    renderCell?: (rowData: any) => JSX.Element;
    redirectFunction?: (rowData: any) => void;
    showRedirectIconFunction?: (rowData: any) => boolean;
    skipRenderCondition?: (rowData: any) => boolean;
    emptyCellWidth?: string;
}

interface SubTableMetaData {
    mappedValue: string;
    columns: ColumnMetaData[];
}

interface MultiLevelTableProps {
    rowData: any[];
    columnsMetaData: ColumnMetaData[]
    footerElement?: () => JSX.Element;
    subTableMetaData?: SubTableMetaData;
    subTableRowIds?: string[];
}

const MultiLevelTable = ({ rowData, columnsMetaData, subTableMetaData, footerElement, subTableRowIds }: MultiLevelTableProps) => {
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");

    const renderCellContent = (col: ColumnMetaData, row: any) => {
        if (col.renderCell) {
            return col.renderCell(row);
        }

        if (!col.mappedValue) {
            return '';
        }

        const value = row[col.mappedValue];

        switch (col.displayType) {
            case 'amount':
                return typeof value === 'number' ? `${ConfigDictionary.currency} ${value.toFixed(2)}` : value;
            case 'quantity':
                return renderMultiQtyCell(col, row);
            default:
                return <div className="cell-content">{value}</div>;
        }
    };

    const renderMultiQtyCell = (col: ColumnMetaData, row: any) => {
        const parts = col.mappedValue?.split(',');
        if (!parts) return '';
        return <>
            <div>
                <MultiQtyCell
                    csQty={row[parts[0]]}
                    pcQty={row[parts[1]]}
                    otherQty={row[parts[2]]}
                    hasEditButton={false}
                    otherUnitName={row.otherUnitName}
                />
            </div>
            {col.redirectFunction && (!col.showRedirectIconFunction || col.showRedirectIconFunction(row)) &&
                <div>
                    <button className="MultiQtyCell_edit-button" onClick={() => col.redirectFunction?.(row)}>
                        <RenderSvg name={"viewAndEditIcon"} />
                    </button>
                </div>
            }
        </>
    }

    return (
        <div className="multi-level-table">
            <div className="table-header">
                <div className="table-row">
                    {columnsMetaData.map((col, idx) => {
                        return (
                            <>
                                <div key={idx} className="table-cell header-cell" style={{ width: col.width }}>
                                    {col.headerName}
                                    {col.hasEditPenSvg && (
                                        <div style={{ marginLeft: "5px" }}>
                                            <EditPen style={{ width: "9px", paddingTop: "5px" }} />
                                        </div>
                                    )}
                                </div>
                            </>
                        )
                    })}
                </div>
            </div>
            <div className="table-body">
                {rowData.map((row, rowIdx) => (
                    <React.Fragment key={rowIdx}>
                        <div className="table-row">
                            {columnsMetaData.map((col, colIdx) => (
                                <div key={colIdx} className="table-cell" style={{ width: col.width, justifyContent: col.align }}>
                                    {col.skipRenderCondition?.(row) ? 
                                        <div style={{justifyContent: "center", display: "flex", width: col.emptyCellWidth ?? "100%"}}>-</div> 
                                        : 
                                        renderCellContent(col, row)}
                                </div>
                            ))}
                        </div>
                        {subTableMetaData && subTableRowIds?.includes(row.id) && (
                            <div className="sub-table-container">
                                <MultiLevelSubTable
                                    rowData={row[subTableMetaData.mappedValue] || []}
                                    columnsMetaData={subTableMetaData.columns}
                                    otherUnitName= {row.otherUnitName}
                                    
                                />
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
            {footerElement && (
                <div className="table-footer">
                    <div className="table-row">
                        <div className="table-cell footer-cell">
                            {footerElement()}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MultiLevelTable;

